import React from "react";
import "../styles/skills.scss";
import HashLoader from "react-spinners/HashLoader";

export default function Skills() {
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return loading ? (
    <HashLoader
      className="loader"
      size={150}
      color={"#0a192f"}
      loading={loading}
    />
  ) : (
    <div className="skills-page-container">
      <p className="skills-bg">SKILLS</p>
      <h1 className="skills-header">skills & experience</h1>
      <div className="skills-header-devider"></div>
      <div className="skills-description-bar">
        <p className="skills-description">
         Web Developer with 3+ years of experience building high-performing and scalable MERN stack applications. Skilled in developing responsive front-end interfaces and robust backend systems using modern web technologies. Strong understanding of the software development life cycle (SDLC) with experience in identifying, debugging, and resolving issues efficiently. Passionate about delivering clean, reliable, and user-friendly applications while maintaining high code quality and performance standards.
          <a
            target="blank"
            href="https://www.linkedin.com/in/sofoniyas-alemu?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BufZJhWL%2BREetHf9o4QQjSA%3D%3D"
          >
            LinkedIn profile
          </a>{" "}
          for more details or just contact me.
        </p>
        <div className="skills-bar-experience-box">
          <div className="skills-bar-container">
            <div className="skills-bar">
              <p className="skills-bar-title">HTML / HTML5</p>
              <div className="skills-bar-one"></div>
            </div>
            <div className="skills-bar">
              <p className="skills-bar-title">CSS / CSS3</p>
              <div className="skills-bar-two"></div>
            </div>
            <div className="skills-bar">
              <p className="skills-bar-title">Frameworks (Bootstrap, Tailwindcss)</p>
              <div className="skills-bar-three"></div>
            </div>
            <div className="skills-bar">
              <p className="skills-bar-title"> Js-Libraries (React,node, Jquery, Three.js)
              </p>
              <div className="skills-bar-four"></div>
            </div>
            <div className="skills-bar">
              <p className="skills-bar-title">Next.js</p>
              <div className="skills-bar-seven"></div>
            </div>
            <div className="skills-bar">
              <p className="skills-bar-title">PostgreSQL , MongoDB</p>
              <div className="skills-bar-five"></div>
            </div>
            
          </div>
          <div className="experience-box">
            <div className="skills-experience">
              <h3 className="experience-one-title">Software-developer</h3>
              <p className="experience-one-time">
                {" "}
                skills
              </p>
              <p className="experience-one-subtitle">Disciplined and tech enthusiastic person, who is motivated to combine
          the art of design with the art of programming.  I have
          a considerable years of experience as a frontend web developer, backend and
          software tester. I am always learning new skills to be the
          professional who I want to become.</p>
              <div className="experience-one-subtitle">
                <li>
                  React
                </li>
                <li>Next.js</li>
                <li>
                  MongoDB,mysql,postgresql
                </li>
                <li>
                 Rest-api, Graphql
                </li>
                <li>
                  Three.js, Framer-motion
                </li>
                <li>
                 Tailwindcss, bootstrap5
                </li>
                <li>Wordpress</li>{" "}
                <li>
                  tensor-flow, phytorch
                </li>{" "}
                <li>
                 flutter,react-native
                </li>
              </div>
            </div>
            <div className="skills-experience">
              <h3 className="experience-one-title">Freelance Web Developer</h3>
              <p className="experience-one-time"> Addis Ababa, Ethiopia</p>
              <p className="experience-one-time">Jan 2022 - Present</p>
              <p className="experience-one-subtitle">
                Creating and maintaining websites using technologies such as
                ReactJS, NodeJS, ExpressJs, MongoDB, JavaScript, HTML, CSS, and
                various content management systems. Skilled in front-end and
                MERN stack development and able to create visually appealing
                fully functional, high performance and user-friendly web apps
                that meet client needs.
                <li>
                  Working with clients to understand their needs and develop
                  custom websites that met their requirements.
                </li>
                <li>
                  Experienced working with the technologies in the MERN stack:
                  MongoDB, ExpressJs, ReactJs and NodeJs.
                </li>
                <li>
                  Working with common frontend development tools such as Babel,
                  Webpack, NPM React.js workflows.
                </li>
                <li>
                  Utilizing HTML, CSS, JavaScript, ReactJS, and other front-end
                  technologies to create visually appealing and user-friendly
                  websites.
                </li>
                <li>
                  Communicating effectively with clients throughout the
                  development process to ensure their satisfaction with the
                  final product
                </li>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
